var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z",
    fill: "#6B47F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 7C12.1642 7 12.5 7.33579 12.5 7.75V8.75C12.5 9.16421 12.1642 9.5 11.75 9.5C11.3358 9.5 11 9.16421 11 8.75V7.75C11 7.33579 11.3358 7 11.75 7ZM11.75 10.5C12.1642 10.5 12.5 10.8358 12.5 11.25V15.75C12.5 16.1642 12.1642 16.5 11.75 16.5C11.3358 16.5 11 16.1642 11 15.75V11.25C11 10.8358 11.3358 10.5 11.75 10.5Z",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/Tooltip.ff57d6b49008c6d61a1dca668c3a5644.svg";
export { ForwardRef as ReactComponent };